<!-- eslint-disable -->
<script setup>
import { useOddsStore } from '@/stores/odds';

const oddsStore = useOddsStore();

</script>

<template>
	<div class="content-main">
		<div class="title-main">
				<svg class="normal-img"
					xmlns="http://www.w3.org/2000/svg" xml:space="preserve" version="1.1"
					style="shape-rendering:geometricPrecision; fill: var(--white); width: 33px; height: 33px; margin-top: 6px; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
					viewBox="0 0 34 34" xmlns:xlink="http://www.w3.org/1999/xlink">
					<use :xlink:href="'/assets/icons/odd-ico.svg#svg3108'"/>
				</svg>
			<h3>{{ $t('general.odds_format') }}</h3>
		</div>
		<form>
			<div class="lang-options">
				<div  class="radio-btn" @click="oddsStore.changeOddsPreview('decimal')">
					<input :checked="'decimal' == oddsStore.getOddsPreview || oddsStore.getOddsPreview == null" type="radio" name="odds" value="decimal">
					<label>{{ $t('general.decimal') }}</label>
				</div>
				<div class="radio-btn" @click="oddsStore.changeOddsPreview('american')">
					<input :checked="'american' == oddsStore.getOddsPreview" type="radio" name="odds" value="american">
					<label>{{ $t('general.american') }}</label>
				</div>
				<!-- <div class="radio-btn" @click="oddsStore.changeOddsPreview('fractional')">
					<input :checked="'fractional' == oddsStore.getOddsPreview" type="radio" name="odds" value="fractional">
					<label>{{ $t('general.fractional') }}</label>
				</div> -->
			</div>
		</form>
	</div>
</template>